import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'portfolio-3-portfolio.app-simple-plans.twp-benefits-modal.title',
		defaultMessage: 'Your teams have moved!',
		description: 'The title for the twp benefits modal',
	},
	plansContentSpork: {
		id: 'portfolio-3-portfolio.app-simple-plans.twp-benefits-modal.plans-content-spork',
		defaultMessage:
			'Your Shared teams in Plans are now available across all of Jira. To view and manage them, navigate to the <strong>People</strong> tab at the top of the screen.',
		description:
			'The content for the twp benefits modal. The translation for "People" in this text needs to match the message id `atlassian-navigation.people.title`',
	},
});
